import {
  BellIcon,
  Button,
  MuiAppBar,
  MuiIconButton,
  MuiToolbar
} from "@dealer-center/core-components";
import { footerHeight, minWidth } from "@dealer-center/core-custom-components";
import { PendoButton } from "./pendo-button";
import { backgroundColor } from "../const";

export const bottomBarlinks = [
  {
    label: "Terms of Service",
    href: "https://www.coxautoinc.com/terms/wp-content/uploads/sites/3/Common-Customer-TOU.pdf"
  },
  {
    label: "Privacy Policy",
    href: "https://www.coxautoinc.com/privacy-statement"
  },
  { label: "Contact Us", href: "https://casfx.my.site.com/ddc/s" }
];

export const BottomBar = () => (
  <MuiAppBar
    position="relative"
    sx={{
      flexShrink: 0,
      minWidth,
      backgroundColor
    }}
  >
    <MuiToolbar
      sx={{
        display: "flex",
        gap: 2,
        minHeight: `${footerHeight}px !important`,
        justifyContent: "right",
        alignItems: "center",
        "&>button": {
          width: "auto"
        }
      }}
      variant="dense"
    >
      {bottomBarlinks.map(link => (
        <Button
          analyticsConfiguration={{
            eventName: "click",
            eventProperties: {
              component: "bottomBar",
              actionContext: "click",
              actionValue: link.label,
              errorMessage: "",
              label: link.label
            }
          }}
          buttonStyle="aux"
          key={link.label}
          sx={{ my: "4px", color: "white", display: "block" }}
          onClick={() => {
            window.open(link.href, "_blank");
          }}
        >
          {link.label}
        </Button>
      ))}

      <MuiIconButton
        aria-label="show notifications spacer"
        color="inherit"
        size="large"
        sx={{
          height: "0px",
          visibility: "hidden"
        }}
      >
        <BellIcon id="notification-area-spacer" title={"NotificationsSpacer"} />
      </MuiIconButton>
      <PendoButton />
    </MuiToolbar>
  </MuiAppBar>
);
